import React, { useRef, useState } from "react";
import "./poultory.css";
import { Carousel, Button, Row, Col, Alert, Modal } from "antd";
import {
  UsergroupAddOutlined,
  HighlightOutlined,
  BellOutlined,
  UserOutlined,
  HeartOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import "antd/dist/antd.css";
import emailjs from "@emailjs/browser";

// Components
import Header from "../../components/Header/index";
import Layout from "antd/lib/layout/layout";
import Maincard from "../../components/Maincard";
import Featurescard from "../../components/Featurescard";
import Footer from "../../components/Footer";
import ProductCard from "../../components/productCards";
import ReactWhatsapp from "react-whatsapp";
import Teamcard from "../../components/Teamcard";
import Products from "../../Data/products/products.json";

// Images
import work from "../../assets/Images/work.jpg";
import profile from "../../assets/Images/profile.jpg";
import egg from "../../assets/Images/eggs.png";
import hen from "../../assets/Images/hen.jpg";
import hen2 from "../../assets/Images/hen2.jpg";
import hen3 from "../../assets/Images/hen3.png";
import hen4 from "../../assets/Images/hen4.png";
import poultryLogo from "../../assets/Images/poultry.png";
import issa from "../../assets/Images/issa.jpeg";
import CEO from "../../assets/Images/CEO.jpg";
import abs from "../../assets/Images/abs.jpg";
import chicken from "../../assets/Images/chicken.jpeg";
import farm from "../../assets/Images/farm.jpg";

import styles from "./styles";

const charges = {
  packing: "200",
  delivery: "200",
};

const Poultory = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isAlert, setIsAlert] = useState(false);
  const [productName, setProductName] = useState("");
  const [productPrice, setProductPrice] = useState("");
  const [productImg, setProductImg] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [quantity, setQuantity] = useState("1");

  const contentStyle = {
    minHeight: "70vh",
    color: "#fff",
    lineHeight: "50px",
    backgroundColor: "#364d79",
  };

  const showModal = (name, price, image) => {
    setIsModalVisible(true);
    setProductName(name);
    setProductPrice(price);
    setProductImg(image);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    setIsLoading(true);
    emailjs
      .sendForm(
        "service_y4oi1lm",
        "template_nmgrw8i",
        form.current,
        "dJcLdJeshjYPvNz7V"
      )
      .then(
        (result) => {
          console.log(result.text);
          setIsLoading(false);
          e.target.reset();
          setIsAlert(true);
          setTimeout(() => {
            setIsAlert(false);
          }, 2000);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  const OrderNow = (e) => {
    e.preventDefault();

    setIsLoading(true);
    emailjs
      .sendForm(
        "service_y4oi1lm",
        "template_sdfpv5a",
        form.current,
        "dJcLdJeshjYPvNz7V"
      )
      .then(
        (result) => {
          console.log(result.text);
          setIsLoading(false);
          e.target.reset();
          setIsAlert(true);
          setTimeout(() => {
            setIsAlert(false);
          }, 2000);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  let width = window.innerWidth;

  return (
    <div id="home">
      <Header brandLogo={poultryLogo} />
      {/* brandName="broshall poultory farms GB"  */}
      {/* Hero Section */}
      <section>
        <Carousel id="hero">
          <div>
            <div style={contentStyle} className="carouselItem carouselDiv">
              <div className="container">
                <Row gutter={16} className="carousel-row">
                  <Col
                    className="gutter-row"
                    sx={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 18 }}
                  >
                    <Button type="primary" shape="round" size="large">
                      Welcome to Broshall
                    </Button>
                    <h2 className="text-white carouselHeading">
                      Broshall Poultory Farms Pvt Ltd Gilgit Baltistan.
                    </h2>
                    <p className="text-white carouselPara">
                      Broshall Poultory Farms Pvt Ltd GB aims to produce and
                      provide orangic desi hens as well as eggs. Enhance in all
                      provinces of Pakistan.
                    </p>
                    <div className="carouselBtns">
                      <Button shape="round" size="large" className="btn1">
                        Learn More
                      </Button>
                      <Button shape="round" size="large" className="btn2">
                        Contact us
                      </Button>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          <div>
            <div style={contentStyle} className="carouselItem carouselDiv">
              <div className="container">
                <Row gutter={16} className="carousel-row">
                  <Col
                    className="gutter-row"
                    sx={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 18 }}
                  >
                    <Button type="primary" shape="round" size="large">
                      Welcome to Broshall
                    </Button>
                    <h2 className="text-white carouselHeading">
                      Broshall Poultory Farms Pvt Ltd Gilgit Baltistan.
                    </h2>
                    <p className="text-white carouselPara">
                      Broshall Poultory Farms Pvt Ltd GB aims to produce and
                      provide orangic desi hens as well as eggs. Enhance in all
                      provinces of Pakistan.
                    </p>
                    <div className="carouselBtns">
                      <Button shape="round" size="large" className="btn1">
                        Learn More
                      </Button>
                      <Button shape="round" size="large" className="btn2">
                        Contact us
                      </Button>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          <div>
            <div style={contentStyle} className="carouselItem carouselDiv">
              <div className="container">
                <Row gutter={16} className="carousel-row">
                  <Col
                    className="gutter-row"
                    sx={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 18 }}
                  >
                    <Button type="primary" shape="round" size="large">
                      Welcome to Broshall
                    </Button>
                    <h2 className="text-white carouselHeading">
                      Broshall Poultory Farms Pvt Ltd Gilgit Baltistan.
                    </h2>
                    <p className="text-white carouselPara">
                      Broshall Poultory Farms Pvt Ltd GB aims to produce and
                      provide orangic desi hens as well as eggs. Enhance in all
                      provinces of Pakistan.
                    </p>
                    <div className="carouselBtns">
                      <Button shape="round" size="large" className="btn1">
                        Learn More
                      </Button>
                      <Button shape="round" size="large" className="btn2">
                        Contact us
                      </Button>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </Carousel>
      </section>

      <Layout style={{ backgroundColor: "#fff" }}>
        <Row className="container">
          <Col sm={24} style={styles.features}>
            <div>
              <h1 style={styles.choose} className="choose">
                Why choose us
              </h1>
              <p style={styles.homePara} className="home-para">
                Explore our features
              </p>
              <span className="featuresSpan"></span>
            </div>
          </Col>
        </Row>
        <Row className="container" style={{ paddingBottom: "80px" }}>
          <Col xs={24} sm={12} md={12} lg={12} xl={6}>
            <Featurescard
              cardHeading="most Experienced"
              bgImage={poultryLogo}
              cardIcon={<UserOutlined />}
              cardPara="We have the most Experienced team members"
            />
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={6}>
            <Featurescard
              cardHeading="healty food"
              bgImage={chicken}
              cardIcon={<HighlightOutlined />}
              cardPara="Take a step that is new. We've a loveable spa that needs your face threes company too."
            />
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={6}>
            <Featurescard
              cardHeading="Natural Chicken"
              bgImage={farm}
              cardIcon={<BellOutlined />}
              cardPara="Take a step that is new. We've a loveable spa that needs your face threes company too."
            />
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={6}>
            <Featurescard
              cardHeading="Desi Eggs"
              bgImage={egg}
              cardIcon={<UsergroupAddOutlined />}
              cardPara="Take a step that is new. We've a loveable spa that needs your face threes company too."
            />
          </Col>
        </Row>
      </Layout>

      <section id="aboutus">
        <Layout>
          <Row className="aboutSection">
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <div className="container">
                <div style={styles.aboutusDiv}>
                  <div>
                    <h2 style={styles.choose} className="aboutHeading">
                      About us
                    </h2>
                    <p style={styles.homePara} className="aboutPara">
                      Trout is a great source of protein with three-ounces
                      containing about 19 grams. Broshall Fish Farms Pvt Ltd GB
                      aims to produce organic trout fish in GB and will be
                      export. Enhace to all districts of GB. Our aims to provide
                      good quality works, produce organic trout fish, produce
                      and provide orangic desi hens and eggs and enhance tourism
                      in GB.
                    </p>
                    <a href="#" className="aboutLink">
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={12}
              className="aboutDiv"
            ></Col>
          </Row>
        </Layout>
      </section>

      <Layout>
        <div className="carouselCards">
          <div>
            <Row>
              <Col sm={24} style={styles.features}>
                <div style={{ lineHeight: "50px" }}>
                  <h1
                    style={styles.choose}
                    className="text-white productsHeading"
                  >
                    Poultory PRODUCTS FROM OUR SHOP
                  </h1>
                  <p style={styles.homePara} className="productPara">
                    Explore Our Latest Products For Your Fine poultory
                  </p>
                </div>
              </Col>
            </Row>
            <Carousel>
              <div style={{ marginBottom: "0px" }}>
                <div style={contentStyle} className="productDiv">
                  <Row
                    className="contain"
                    style={{ paddingBottom: "30px" }}
                    gutter={24}
                  >
                    {Products?.poultoy?.map((item, index) => {
                      return (
                        <Col xs={24} sm={12} md={12} lg={6} xl={6} key={index}>
                          <ProductCard
                            new={
                              item?.oldPrice ? `${item?.price}  / kg` : "New"
                            }
                            heart={<HeartOutlined />}
                            image={
                              item?.image === "hen"
                                ? hen
                                : item?.image === "hen2"
                                ? hen2
                                : item?.image === "hen3"
                                ? hen3
                                : item?.image === "egg"
                                ? egg
                                : ""
                            }
                            // image={hen2}
                            sale={
                              item?.oldPrice ? `${item?.oldPrice}  / kg` : ""
                            }
                            OnClick={() =>
                              showModal(
                                item?.productName,
                                item?.price,
                                item?.image === "hen"
                                  ? hen
                                  : item?.image === "hen2"
                                  ? hen2
                                  : item?.image === "hen3"
                                  ? hen3
                                  : item?.image === "egg"
                                  ? egg
                                  : ""
                              )
                            }
                            cardHeading={item?.productName}
                            price={`Rs. ${item?.price} / ${
                              item?.productName === "Desi Eggs" ? "Dozan" : "kg"
                            }`}
                            cardBtn="Order Now"
                            cardPara={item?.description}
                          />
                        </Col>
                      );
                    })}
                  </Row>
                </div>
              </div>
              <div>
                <div style={contentStyle} className="productDiv">
                  <Row
                    className="contain"
                    style={{ paddingBottom: "30px" }}
                    gutter={24}
                  >
                    <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                      <ProductCard
                        new="new"
                        heart={<HeartOutlined />}
                        image={hen}
                        OnClick={() => showModal("Desi Hen", "RS. 500/KG", hen)}
                        cardHeading="Desi Hen"
                        price="500 PKR /KG"
                        cardBtn="add to cart"
                        cardPara="Chicken is highly nutritious and a good source of protein. Adding chicken 
                              to your diet may help support muscle growth."
                      />
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                      <ProductCard
                        new="new"
                        heart={<HeartOutlined />}
                        image={egg}
                        OnClick={() =>
                          showModal("Desi Eggs", "RS. 350/KG", egg)
                        }
                        cardHeading="Desi Eggs"
                        price=" 350 PKR/dosen"
                        cardBtn="add to cart"
                        cardPara="Desi eggs are propagated to be healthier than white eggs, they are also more expensive than their white variety."
                      />
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                      <ProductCard
                        new="350 PKR"
                        sale="400 PKR"
                        heart={<HeartOutlined />}
                        image={hen3}
                        OnClick={() =>
                          showModal("Desi Chickens", "RS. 350/KG", hen3)
                        }
                        cardHeading="Desi Chickens"
                        price="350 PKR /KG"
                        cardBtn="add to cart"
                        cardPara="Chicken is highly nutritious and a good source of protein. Adding chicken 
                              to your diet may help support muscle growth."
                      />
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                      <ProductCard
                        new="new"
                        heart={<HeartOutlined />}
                        image={hen4}
                        OnClick={() =>
                          showModal("Desi Chickens", "RS. 450/KG", hen4)
                        }
                        cardHeading="Desi Chickens"
                        price="450 PKR /KG"
                        cardBtn="add to cart"
                        cardPara="Chicken is highly nutritious and a good source of protein. Adding chicken 
                              to your diet may help support muscle growth."
                      />
                    </Col>
                  </Row>
                </div>
              </div>
              <div style={{ marginBottom: "0px" }}>
                <div style={contentStyle} className="productDiv">
                  <Row
                    className="contain"
                    style={{ paddingBottom: "30px" }}
                    gutter={24}
                  >
                    <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                      <ProductCard
                        new="new"
                        heart={<HeartOutlined />}
                        image={hen}
                        OnClick={() => showModal("Desi Hen", "RS. 500/KG", hen)}
                        cardHeading="Desi Hen"
                        price="500 PKR /KG"
                        cardBtn="add to cart"
                        cardPara="Chicken is highly nutritious and a good source of protein. Adding chicken 
                              to your diet may help support muscle growth."
                      />
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                      <ProductCard
                        new="new"
                        heart={<HeartOutlined />}
                        image={egg}
                        OnClick={() =>
                          showModal("Desi Eggs", "RS. 350/KG", egg)
                        }
                        cardHeading="Desi Eggs"
                        price=" 350 PKR/dosen"
                        cardBtn="add to cart"
                        cardPara="Desi eggs are propagated to be healthier than white eggs, they are also more expensive than their white variety."
                      />
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                      <ProductCard
                        new="350 PKR"
                        sale="400 PKR"
                        heart={<HeartOutlined />}
                        image={hen3}
                        OnClick={() =>
                          showModal("Desi Chickens", "RS. 350/KG", hen3)
                        }
                        cardHeading="Desi Chickens"
                        price="350 PKR /KG"
                        cardBtn="add to cart"
                        cardPara="Chicken is highly nutritious and a good source of protein. Adding chicken 
                              to your diet may help support muscle growth."
                      />
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                      <ProductCard
                        new="new"
                        heart={<HeartOutlined />}
                        image={hen4}
                        OnClick={() =>
                          showModal("Desi Chickens", "RS. 450/KG", hen4)
                        }
                        cardHeading="Desi Chickens"
                        price="450 PKR /KG"
                        cardBtn="add to cart"
                        cardPara="Chicken is highly nutritious and a good source of protein. Adding chicken 
                              to your diet may help support muscle growth."
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            </Carousel>
            <Row>
              <Col
                sm={24}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "15vh",
                  margin: "0 auto",
                }}
              >
                <button className="allProducts">View all products</button>
              </Col>
            </Row>
          </div>
        </div>
      </Layout>
      <section id="ourteam">
        <Layout style={{ paddingBottom: "150px", paddingTop: "80px" }}>
          <div className="container">
            <Row>
              <Col xs={24} sm={24} lg={24}>
                <div style={styles.ourTeamDiv}>
                  <h2 style={styles.choose}>Meet Our Team</h2>
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                <Teamcard
                  teamHeading="Muhammad Shafa"
                  bgImage={abs}
                  teamPara="ceo"
                />
              </Col>
              <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                <Teamcard
                  teamHeading="Muhammad Ismail"
                  bgImage={CEO}
                  teamPara="chairman"
                />
              </Col>
              <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                <Teamcard
                  teamHeading="Muhammad Issa"
                  bgImage={issa}
                  teamPara="manager"
                />
              </Col>
              <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                <Teamcard
                  teamHeading="Ali Haider"
                  bgImage={profile}
                  teamPara="Accountant"
                />
              </Col>
            </Row>
          </div>
        </Layout>
      </section>

      <section id="contact">
        <Layout>
          <div className="container">
            <Row>
              <Col
                sx={20}
                sm={22}
                md={24}
                lg={24}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "50px",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <h2>Let us hear from you directly!</h2>
                  <p>
                    We always wants to hear from you! Let us know how we can
                    best help you and we'll do our very best.
                  </p>
                </div>
              </Col>
            </Row>
            <Row className="container">
              <Col span="24">
                <form
                  ref={form}
                  onSubmit={sendEmail}
                  autocomplete="off"
                  className="sentEmailForm"
                >
                  <Row>
                    <Col span={24}>
                      <label style={styles.label}>Full Name:</label>
                      <input
                        type="text"
                        name="name"
                        autocomplete="off"
                        style={styles.mesInput}
                        className="loginINput"
                        placeholder="Full Name"
                        required
                      />
                    </Col>
                    <Col span={24}>
                      <label style={styles.label}>Email:</label>
                      <input
                        type="email"
                        name="email"
                        autocomplete="off"
                        style={styles.mesInput}
                        className="loginINput"
                        placeholder="jhondoe@gmail.com"
                        required
                      />
                    </Col>
                    <Col span={24}>
                      <label style={styles.label}>Subject:</label>
                      <input
                        type="text"
                        name="subject"
                        autocomplete="off"
                        style={styles.mesInput}
                        className="loginINput"
                        placeholder="Subject"
                        required
                      />
                    </Col>
                    <Col span={24}>
                      <label style={styles.label}>Message:</label>
                      <textarea
                        rows={5}
                        style={styles.mesTextArea}
                        name="message"
                        placeholder="Type your message..."
                      />
                    </Col>
                    <Col sx={20} sm={22} md={24} lg={24}>
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="loginBtn"
                      >
                        {isLoading ? (
                          <span>
                            <SyncOutlined spin /> loading
                          </span>
                        ) : (
                          <span>Send Message</span>
                        )}
                      </Button>
                      {isAlert && (
                        <Alert
                          message="Message sent Successfully!"
                          type="success"
                          style={{ marginTop: "20px" }}
                          showIcon
                        />
                      )}
                    </Col>
                  </Row>
                </form>
              </Col>
            </Row>
          </div>
        </Layout>
      </section>

      <div id="cartToggle">
        <Modal
          id="loginModal"
          visible={isModalVisible}
          onOk={handleOk}
          onCancel={handleCancel}
          width={width < 556 ? "100%" : "65%"}
        >
          {/* <Layout> */}
          <div className="container">
            <Row>
              <Col
                sx={20}
                sm={22}
                md={24}
                lg={24}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "50px",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <h2>Let order now for out Products!</h2>
                  <p>
                    We always wants to deliver the best product to you! Let us
                    know how we can best help you and we'll do our very best.
                  </p>
                </div>
              </Col>
            </Row>
            <Row className="container">
              <Col span="24">
                <form ref={form} autocomplete="off" onSubmit={OrderNow}>
                  <Row>
                    <Col
                      sm={24}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column",
                      }}
                    >
                      <input
                        type="text"
                        name="product"
                        autocomplete="off"
                        value={productName}
                        style={{ fontSize: "20px", marginLeft: "7rem" }}
                        className="loginDisabledINput"
                      />
                      <img src={productImg} width="300" />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={24} md={6}>
                      <h3>Product Price</h3>
                      <input
                        type="text"
                        name="price"
                        autocomplete="off"
                        value={`${productPrice} / ${
                          productName === "Desi Eggs" ? "Dozan" : "kg"
                        }`}
                        className="loginDisabledINput"
                      />
                    </Col>
                    <Col sm={24} md={6}>
                      <h3>Packing charges</h3>
                      <input
                        type="text"
                        name="packing"
                        autocomplete="off"
                        value={`${charges?.packing} / ${
                          productName === "Desi Eggs" ? "Dozan" : "kg"
                        }`}
                        className="loginDisabledINput"
                      />
                    </Col>
                    <Col sm={24} md={6}>
                      <h3>Delivery charges</h3>
                      <input
                        type="text"
                        name="delivery"
                        autocomplete="off"
                        value={`${charges?.delivery} / ${
                          productName === "Desi Eggs" ? "Dozan" : "kg"
                        }`}
                        className="loginDisabledINput"
                      />
                    </Col>
                    <Col sm={24} md={6}>
                      <h3>Total</h3>
                      <input
                        type="text"
                        name="total"
                        autocomplete="off"
                        value={
                          "Rs. " +
                          (parseInt(productPrice) +
                            parseInt(charges?.delivery) +
                            parseInt(charges?.packing)) *
                            parseInt(quantity) +
                          " /- only"
                        }
                        className="loginDisabledINput"
                      />
                    </Col>
                  </Row>
                  <Row
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Col sm={24} md={11}>
                      <label style={styles.label}>Full Name:</label>
                      <input
                        type="text"
                        name="name"
                        autocomplete="off"
                        style={styles.mesInput}
                        className="loginINput"
                        placeholder="Full Name"
                        required
                      />
                    </Col>
                    <Col sm={24} md={11}>
                      <label style={styles.label}>Quantity:</label>
                      <input
                        type="text"
                        name="quantity"
                        autocomplete="off"
                        onChange={(e) => setQuantity(e.target.value)}
                        style={styles.mesInput}
                        className="loginINput"
                        placeholder="Quantity"
                        required
                      />
                    </Col>
                    <Col sm={24} md={11}>
                      <label style={styles.label}>Email:</label>
                      <input
                        type="email"
                        name="email"
                        autocomplete="off"
                        style={styles.mesInput}
                        className="loginINput"
                        placeholder="jhondoe@gmail.com"
                        required
                      />
                    </Col>
                    <Col sm={24} md={11}>
                      <label style={styles.label}>Mobile No:</label>
                      <input
                        type="number"
                        name="contact"
                        autocomplete="off"
                        style={styles.mesInput}
                        className="loginINput"
                        placeholder="03129747223"
                        required
                      />
                    </Col>
                    <Col sm={24}>
                      <label style={styles.label}>Postal Address:</label>
                      <input
                        type="text"
                        name="address"
                        autocomplete="off"
                        style={styles.mesInput}
                        className="loginINput"
                        placeholder="Address"
                        required
                      />
                    </Col>
                    <Col
                      sx={20}
                      sm={22}
                      md={24}
                      lg={24}
                      style={{ marginTop: "20px" }}
                    >
                      <div className="whatapp-div">
                        <Button
                          type="primary"
                          htmlType="submit"
                          className="loginBtn"
                        >
                          {isLoading ? (
                            <span>
                              <SyncOutlined spin /> loading
                            </span>
                          ) : (
                            <span>Buy Now</span>
                          )}
                        </Button>
                      </div>
                      {isAlert && (
                        <Alert
                          message="Order sent successfully! We will respond on your email, Please check your email."
                          type="success"
                          style={{ marginTop: "20px" }}
                          showIcon
                        />
                      )}
                    </Col>
                  </Row>
                </form>
                <div className="whatapp-div">
                  <h1>OR</h1>
                  <div className="content">
                    <section className="library">
                      <ReactWhatsapp
                        number={"+923554508231"}
                        message={`
                        https://broshall.vercel.app/home  Hello, I need ${productName} of Quantity: `}
                      >
                        Open Whatsapp
                      </ReactWhatsapp>
                    </section>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          {/* </Layout> */}
        </Modal>
      </div>

      <section id="footer">
        <Layout>
          <Footer />
        </Layout>
      </section>
    </div>
  );
};
export default Poultory;
